<!--
    Summary:
        hkml.exhibition.web - articles
    ChangeLog:
        wangn on 2020/11/29 added
-->
<template>
    <div class="v-articles" title="articles">
      <sub-banner id="id_about">
        <img src="../../../assets/images/news/p1.png"/>
        <div slot="title">
          {{$t('New_NavBar.MediaCentre')}}
        </div>
        <a href="/" slot="action">{{$t('ContactUsText.p1_action')}}</a>
      </sub-banner>

      <media-center-pagination></media-center-pagination>
    </div>
</template>

<script>
  import SubBanner from "@/components/sub-banner";
  import MediaCenterPagination from "./media-center-pagination";

  export default {
    components: {MediaCenterPagination, SubBanner},
    computed: {
      isEng: function () {
        return this.$i18n.locale == 'en-US';
      }
    },
  }
</script>

<style scoped lang="scss">
    .v-articles {
    }
</style>




// WEBPACK FOOTER //
// src/view/news/media-center/media-center.vue